/* eslint-disable react/destructuring-assignment */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ContextMenuTrigger } from 'react-contextmenu';
import SharedTable from 'shared/ui/Table';
import ContextMenuWorkspaceMassiveUpdate from 'Screens/Contextualization/Workspaces/components/ContextMenuWorkspaceMassiveUpdate';
import { setOrderByWorkspaces } from 'Screens/Contextualization/Workspaces/actions/Actions';
import {
  selectIsFetching, selectWorkspacesOrdered, selectWorkspacesSelected, selectShowWsDetail
} from 'store/Workspace/selectors';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import { PERMISSION_TYPES, FEATURE_WORKSPACES } from 'Hooks/usePermission/permissions';
import { TableWrapper } from './styled';
import workspacesSchema from './schema';
import WorkspaceDetail from '../WorkspaceDetail';
import { selectFields, selectOrderSaved } from 'store/Preferences/workspace/selectors';
import NoSearchResults from 'Common/Components/NoSearchResults';
import { selectIsFiltering } from 'store/Filters/selectors';
import { selectIsLoggedIn } from 'store/Sesion/selectors';
import useTheme from 'Hooks/UseTheme';
import { isEmpty } from 'lodash';

const Table = ({ setShowConfirmation, theme }) => {
  const dispatch = useDispatch();
  const workspacesSelected = useSelector(selectWorkspacesSelected);
  const workspaceList = useSelector(selectWorkspacesOrdered);
  const isFetching = useSelector(selectIsFetching);
  const isFiltering = useSelector((state) => selectIsFiltering('workspaces', state));
  const showDetail = useSelector(selectShowWsDetail);
  const fields = useSelector(selectFields);
  const canUpdate = useSelector((state) => selectAllowedByRole(state, FEATURE_WORKSPACES, PERMISSION_TYPES.UPDATE));
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const [selectedWS, setSelectedWS] = useState({ ws: '', active: false });
  const orderBySaved = useSelector(selectOrderSaved);

  const getSorting = (sorted) => {
    const vulnsSortIndex = sorted.findIndex((s) => s.id === 'vulnerabilities');

    if (vulnsSortIndex >= 0) {
      const desc = sorted[vulnsSortIndex].desc;
      const sortTotalCount = { id: 'vulnerability_total_count', desc };

      const newSorting = [...sorted];
      newSorting.splice(vulnsSortIndex, 1, sortTotalCount);
      return newSorting;
    }
    return sorted;
  };

  const isRowSelected = (rowInfo) => workspacesSelected.filter((x) => x.id === rowInfo.original.id).length > 0;

  const getTrProps = (rowInfo) => ({
    onContextMenu: () => {
      setSelectedWS({ ws: rowInfo.original.name, active: rowInfo.original.active });
    }
  });

  const fetchData = (sorted) => {
    if (!isFetching && isLoggedIn) {
      if (isEmpty(sorted) && !isEmpty(orderBySaved)) {
        const sorting = { id: orderBySaved.field, desc: orderBySaved.direction === 'desc' };
        dispatch(setOrderByWorkspaces([sorting]));
      } else {
        const sorting = getSorting(sorted);
        dispatch(setOrderByWorkspaces(sorting));
      }
    }
  };

  let noDataText = '';
  if (!isFetching) noDataText = isFiltering ? <NoSearchResults /> : 'No workspaces found';

  return (
    <TableWrapper>
      <ContextMenuTrigger id="massive_update_workspace_table" holdToDisplay={ 1000000 } >
        <SharedTable
          schema={ workspacesSchema }
          context={ { isFetching, setShowConfirmation, fields, theme } }
          data={ workspaceList }
          isLoading={ isFetching }
          style={ { height: '95%', boxShadow: '-8px 14px 20px 0px rgba(0, 0, 0, 0.03)' } }
          onFetch={ fetchData }
          getRowProps={ getTrProps }
          isRowSelected={ isRowSelected }
          noDataText={ noDataText }
        />
      </ContextMenuTrigger>
      { canUpdate
        ? <ContextMenuWorkspaceMassiveUpdate trigger="massive_update_workspace_table" setShowConfirmation={ setShowConfirmation } ws={ selectedWS } />
        : null
      }
      { showDetail && <WorkspaceDetail /> }
    </TableWrapper>
  );
};

const ThemedTable = ({ setShowConfirmation }) => {
  const theme = useTheme(); // Get the theme using the hook
  return <Table setShowConfirmation={ setShowConfirmation } theme={ theme } />;
};

export default ThemedTable;
